module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Piano Fingers")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#piano-fingers"
    }
  }, [_vm._v("Piano Fingers")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-heartbroken"
    }
  }, [_vm._v("Chapter 1: Heartbroken")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-signs"
    }
  }, [_vm._v("Chapter 2: Signs")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-3-an-introduction-to-faith",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: An Introduction to Faith")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-the-golden-glow-of-consciousness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Golden Glow of Consciousness")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-a-horse-called-strength",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: A Horse Called Strength")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-fear-meets-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Fear Meets Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-the-pandemic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Pandemic")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-piano-fingers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Piano Fingers")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-power-of-faith",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Power of Faith")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-losing-strength",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Losing Strength")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-the-premonition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Premonition")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-friends-reunite",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Friends Reunite")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-wedding-plans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Wedding Plans")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-lockdown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Lockdown")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-a-dragon-called-wisdom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: A Dragon Called Wisdom")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-research-plan-action",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Research, Plan, Action")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-teamwork",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Teamwork")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-evil-vs-magic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Evil vs Magic")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-green-eyed-goblins",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Green-Eyed Goblins")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-from-fear-to-faith",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: From Fear to Faith")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-21-team-magic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Team Magic")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-22-time-is-running-out",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Time Is Running Out")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-23-the-silver-robe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The Silver Robe")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-24-fresh-start",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Fresh Start")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0